import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, Subject, tap, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from 'src/app/core/models/http.model';
import { IFavouritePayment, IPayment, IPaymentDetails, IScheduledPayment, ITransLimitModel } from 'src/app/models/transfers.model';
import { RetailStock } from 'src/app/retail-common.service';
import { AccountsService } from '../accounts/accounts.service';
import { CustomerService } from '../customer.service';

@Injectable({
  providedIn: 'root'
})
export class TransfersService {

  @Output() emitUnfavourite: EventEmitter<any>;
  populateFavDataFormIfSameNavUrl = new Subject<any>();
  refreshWithfilterPaymentHistory:Subject<any>;
  asideLayoutChange = new Subject<string>();
  favTransfersList: IFavouritePayment[];
  ispaymentEmpty: boolean = true
  paymentHistoryFilterValue;
  isPaymentHistoryFilterEmpty = true;

  initiatSubscribe(){
    this.refreshWithfilterPaymentHistory = new Subject<any>();
  }
  initiatUnSubscribe(){
    this.refreshWithfilterPaymentHistory.unsubscribe();
  }

  transferMenuList: any = [
    {
      id: "payment",
      icon: "new-payment",
      name: "CONTEXTULAMENU.newPayment",
      title: "CONTEXTULAMENU.newPaymentTitle",
      path: ["home", "transfers", "new-payment"],
      additionalDetails: {
        fromNav: 'payment',
        closeNav: ['home', 'transfers']
      }
    },
    {
      id: "addBene",
      icon: "add-payee",
      name: "CONTEXTULAMENU.addBeneficiary",
      title: "CONTEXTULAMENU.addBeneficiaryTitle",
      path: ["home", "transfers", "new-payment"],
      desktopPath: ["home", "transfers", "new-bene"],
      additionalDetails: {
        hideFromAccount: true,
        fromNav: 'addBene',
        closeNav: ['home', 'transfers']
      }
    },
    {
      id: "manageBene",
      icon: "manage-payee",
      name: "CONTEXTULAMENU.managebeneficiary",
      title: "CONTEXTULAMENU.beneficiaryTitle",
      path: ["home", "transfers", "bene-list"],
      additionalDetails: {
        fromNav: 'manageBene',
        hideFromAccount: true,
        closeNav: ['home', 'transfers']
      }
    },
    {
      id: "wib",
      icon: "with-in-bank",
      name: "CONTEXTULAMENU.withInBank",
      title: "CONTEXTULAMENU.withInBankTitle",
      path: ["home", "transfers", "bene-list"],
      paymentType: 'INTBT',
      additionalDetails: {
        fromNav: 'transfers',
        hideFromAccount: true,
        closeNav: ['home', 'transfers']
      }
    },
    {
      id: "domestic",
      icon: "domestic-transfer",
      name: "CONTEXTULAMENU.domesticTransfer",
      title: "CONTEXTULAMENU.domesticTransferTitle",
      path: ["home", "transfers", "bene-list"],
      paymentType: 'ACH',
      additionalDetails: {
        fromNav: 'transfers',
        hideFromAccount: true,
        closeNav: ['home', 'transfers']
      }
    },
    {
      id: "international",
      icon: "international-transfer",
      name: "CONTEXTULAMENU.internationalTransfer",
      title: "CONTEXTULAMENU.internationalTransferTitle",
      path: ["home", "transfers", "bene-list"],
      paymentType: 'SWIFT',
      additionalDetails: {
        fromNav: 'transfers',
        hideFromAccount: true,
        closeNav: ['home', 'transfers']
      }
    }
    // {
    //   id: "manageSI",
    //   icon: "menu-placeholder",
    //   name: "Manage <em>SI</em>",
    //   title: "Manage SI",
    //   path: ["shell", "transfers", "manage-si"]
    // }
  ]


  constructor(private _httpProvider: HttpProviderService, private _accountService: AccountsService, private _customerService: CustomerService, private _commonService: CommonService, private _retailStock: RetailStock) { }

  getTransferMenuList() {
    return this.transferMenuList;
  }

  getSelectedTransferMenuData(menuId: string) {
    const selectedMenuItem = this.transferMenuList.find(item => item.id == menuId);
    return selectedMenuItem;
  }

  getBeneInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      return initial;
    }
    return
  }

  /**
   * 
   * @returns IPayment
   */

  getFavTransaction() {
    if (this.favTransfersList.length == 0) {
      return this.fetchFavTransfers().pipe(map(res => {
        return res;
      }))
    }
    else {
      return of(this.favTransfersList)
    }
  }

  removeFaviourateTransfers(currentFavInvNo) {
    let index = this.favTransfersList.findIndex(favData => favData.inventoryNo === currentFavInvNo)
    if (index > -1) {
      this.favTransfersList.splice(index, 1);
    }
  }

  getFavTransactionById(currentFavInvNo) {
    return this.favTransfersList?.find(favData => favData.tranInventoryNo === currentFavInvNo)

  }

  fetchFavTransfers(): Observable<IFavouritePayment[]> {
    const httpRequest: HttpRequestPayload = {
      resource: "/favouritepayments",
      queryParams: [
        {
          key: 'criteriaDetails',
          value: '{"OrderCriteria": [{ "columnName": "createdOn", "columnType": "Timestamp", "orderType": "desc" }]}'
        }
      ],
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        this.favTransfersList = res.body?.favouritepayments;
        return res.body?.favouritepayments;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }

  /**
   * 
   * @returns IPaymentDetails
   */
  fetchPaymentsHistory(filter): Observable<IPaymentDetails[]> {
    filter = [
      {
        key: 'criteriaDetails',
        value: filter ? filter : '{"FilterExpression": "C1", "FilterCriteria": [{"columnName": "status", "columnType": "String", "conditions": {"searchType": "equals", "searchText": "3"} } ], "OrderCriteria": [{"columnName": "createdOn", "columnType": "Timestamp", "orderType": "desc"} ] }'
      }
    ]
    const httpRequest: HttpRequestPayload = {
      resource: "/payments",
      queryParams: filter,
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        !res || res.body == null || res?.body?.payments?.length == 0 ? this.ispaymentEmpty = true : this.ispaymentEmpty = false;
        return res.body?.payments;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }

  /**
   * 
   * @returns IScheduledPayment
   */
  fetchShedulePaymentsHistory(): Observable<IScheduledPayment[]> {
    const httpRequest: HttpRequestPayload = {
      resource: "/scheduledpayments",
      queryParams: [
        {
          key: 'criteriaDetails',
          value: `{
                    "OrderCriteria": [{"columnName": "createdOn", "columnType": "Timestamp", "orderType": "desc" }],
                    "FilterExpression": "C1",
                    "FilterCriteria": [
                      {
                          "columnName": "status",
                          "columnType": "String",
                          "conditions": {
                              "searchType": "equals",
                              "searchText": "ACTIVE"
                          }
                      }
                    ]
                  }`
        }
      ],
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res.body['scheduledpayments'];
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }
  /**
   * 
   * @returns ISheduledPaymentbyId
   */
  fetchShedulePaymentById(inventoryNo): Observable<IScheduledPayment> {
    const httpRequest: HttpRequestPayload = {
      resource: `/scheduledpayments/${inventoryNo}`,
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res.body['scheduledpayments'];
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }
  /**
   * 
   * @param benePhoto 
   * @returns 
   */
  fetchBeneImage(benePhoto: string) {
    const httpRequest: HttpRequestPayload = {
      resource: `/images/${benePhoto}`,
      queryParams: [
        {
          key: 'imageCategory',
          value: 'beneficiary'
        }
      ],
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res.body?.images;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }

  cancelShedulePayment(referenceNumber: string, payload: any) {
    const httpRequest: HttpRequestPayload = {
      resource: `/cancelscheduledpayment`,
      body: payload,
      method: "POST"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return true;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }

  setTitle(backBtnUrl, searchRequired, serviceDescription) {
    if (this._commonService.isDesktop()) {
      this._retailStock.backBtnUrl = backBtnUrl;
      this._retailStock.searchRequired = searchRequired;
      this._retailStock.serviceDescription = serviceDescription;
    }
  }

  compareWithExistForm(currentFormData, previousFormData) {

    let deepCompare = (arg1, arg2) => {
      if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
        if (Object.prototype.toString.call(arg1) === '[object Object]' || Object.prototype.toString.call(arg1) === '[object Array]') {
          if (Object.keys(arg1).length !== Object.keys(arg2).length) {
            return false;
          }
          return (Object.keys(arg1).every(function (key) {
            return deepCompare(arg1[key], arg2[key]);
          }));
        }
        return (arg1 === arg2);
      }
      return false;
    }

    let trimObj = (obj) => {
      if (!Array.isArray(obj) && typeof obj != 'object') return obj;
        return Object.keys(obj).reduce(function(acc, key) {
          acc[key?.trim()?.toUpperCase()] = typeof obj[key] == 'string'? obj[key].trim()?.toUpperCase() : trimObj(obj[key]);
          return acc;
      }, Array.isArray(obj)? []:{});
    }

    return deepCompare(trimObj(previousFormData), trimObj(currentFormData))

  }



  makeUnFavourite(currentFavInvNo): Observable<any> {
    let inventoryNo = this.getFavTransactionById(currentFavInvNo)?.inventoryNo
    this.removeFaviourateTransfers(inventoryNo);
    const httpRequest: HttpRequestPayload = {
      resource: '/favouritepayments/' + inventoryNo,
      method: "DELETE"
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      return response.body
    },
      catchError((err: IHttpErrorPayload) => {
        return throwError(err)
      })));
  }

  fectchPaymentlimitsByPaymentSystem(payload): Observable<ITransLimitModel> {
    
    const httpRequest: HttpRequestPayload = {
      resource: `/retail/paymentlimits`,
      body: payload,
      method: "POST"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      }));
  }

  getPaymentDescriptionByType(paymentSystem) {
    switch (paymentSystem) {
      case 'INTBT': return 'Within bank'
      case 'SWIFT': return 'International bank'
      case 'OAT': return 'Own account'
      case 'ACH': return ' Domestic bank'
      case 'PAYMENTACH': return 'paymentach'
      case 'PAYMENTSWIFT': return 'paymentswift'
    }
  }

  insufficiantBalanceCheck(debitAccountNumber, amount) {
    if (debitAccountNumber && amount) {
      let actualBalance = this._accountService.getAccountSummaryData(debitAccountNumber)?.actualBalance;
      if (parseFloat(amount) <= actualBalance) {
        return true;
      }
      else {
        return false;
      }
    }
  }
}
